export function normalizeString(value: string) {
  return value?.normalize("NFKC").toLocaleLowerCase();
}
